<template>
  <ul v-if="enableTabs.length" class="at-chat_sidebar_footer">
    <li v-if="enableTabs.includes('contacts')">
      <a href="javascript:void(0);" @click.prevent="activeTab('contacts')" :class="{ 'active' : selectedActiveTab == 'contacts'}" class="guppy-users">
        <em class="at-notify" v-if="requestCount">{{requestCount > 99 ? '+99' : requestCount}}</em>
        <span class="at-infotolltip">{{TRANS.contact_tooltip_txt}}</span>
      </a>
    </li>
    <li v-if="enableTabs.includes('messages')">
      <a href="javascript:void(0);" @click.prevent="activeTab('messages')" :class="{ 'active' : selectedActiveTab == 'messages'}" class="guppy-message-square">
        <em class="at-notify" v-if="messageCount">{{messageCount > 99 ? '+99' : messageCount}}</em>
        <span class="at-infotolltip">{{TRANS.conv_tooltip_txt}}</span>
      </a>
    </li>
    <li v-if="enableTabs.includes('friends')">
      <a href="javascript:void(0);" @click.prevent="activeTab('friends')" :class="{ 'active' : selectedActiveTab == 'friends'}" class="guppy-user-plus"><span class="at-infotolltip">{{TRANS.friend_tooltip_txt}}</span></a>
    </li>
    <li v-if="enableTabs.includes('blocked')">
      <a href="javascript:void(0);" @click.prevent="activeTab('blocked')" :class="{ 'active' : selectedActiveTab == 'blocked'}" class="guppy-user-x"><span class="at-infotolltip">{{TRANS.block_tooltip_txt}}</span></a>
    </li>
    <li v-if="enableTabs.includes('posts')">
      <a href="javascript:void(0);" @click.prevent="activeTab('posts')" :class="{ 'active' : selectedActiveTab == 'posts'}" class="guppy-layers">
        <em class="at-notify" v-if="postmessagesCount">{{postmessagesCount > 99 ? '+99' : postmessagesCount}}</em>
        <span class="at-infotolltip">{{TRANS.post_tooltip_txt}}</span>
      </a>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex';
import { GUPPYCHAT_SETTINGS } from '../../../resources/constants';
import GuppyChatManager from "../../../resources/controller";

export default {
  name: "GuppyChatSidebarFooter",
  data(){
    return{
      tab: GUPPYCHAT_SETTINGS.defaultActiveTab
    }
  },
  computed :mapState({
    messageCount : state => {
      return state.groupChatCount + state.privateChatCount
    },
    postmessagesCount : state => state.postmessagesCount,
    requestCount      : state => {
      if(!GUPPYCHAT_SETTINGS.autoInvite){
        return state.requestCount
      }
      return 0;
    },
    selectedActiveTab : state => state.activeTab,
    enableTabs : function() {
      if(GUPPYCHAT_SETTINGS){
        return GUPPYCHAT_SETTINGS.enabledTabs
      }
      return [];
    },
    defaultActiveTab : function(){
      if(GUPPYCHAT_SETTINGS){
        return GUPPYCHAT_SETTINGS.defaultActiveTab
      }
      return ''
    }
  }),
  methods:{
    activeTab(data){
      this.tab = data;
      this.$store.commit('selectTab', data);
    },
  },
  created(){
    GuppyChatManager.updateGroupMembers();
   
  },
};
</script>

<style>
.at-chat_sidebar_footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: var(--secguppycolor);
  display: flex;
  line-height: 30px;
  justify-content: space-around;
  padding: 0;
  margin: 0;
}
.at-chat_sidebar_footer li {
  display: flex;
  align-items: center;
  list-style-type: none;
  padding: 18px 15px !important;
  margin: 0;
  width: auto !important;
  background: transparent !important;
  border: none !important;
}
.at-chat_sidebar_footer a {
  font-size: 24px;
  color: #fff;
  display: inline-block;
  position: relative;
}
.at-chat_sidebar_footer a.active {
  color: var(--primguppycolor);
}
.at-chat_sidebar_footer a .at-notify {
  pointer-events: none;
  top: -10px;
  left: 100%;
  position: absolute;
  margin-left: -10px;
  -webkit-box-shadow: 0 0 0 3px var(--secguppycolor);
  box-shadow: 0 0 0 3px var(--secguppycolor);
  font-family: var(--secchatfont);
}
</style>